module.exports = __webpack_public_path__ + "static/pic4-03b5585a530cd9e94848b60c75354a16.jpg";